import { useTranslation } from "react-i18next";
import { Mail, Languages } from "lucide-react";
import { cn } from "@/design-system/utils";
import { PublicContactForm } from "./components/PublicContactForm";
import { SURFACE_STYLES } from "@/design-system/lib/surface-styles";
import { PublicClinicShell } from "./components/PublicClinicShell";

export function ContactPage() {
  const { t } = useTranslation(["landing"]);

  return (
    <PublicClinicShell
      seo={{
        title: t("landing:seo.contact_title"),
        description: t("landing:seo.contact_description"),
        path: "/contact",
      }}
    >
      <main className="flex-grow max-w-5xl mx-auto px-6 py-16 w-full">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl font-bold tracking-tight mb-4">
            {t("landing:contact.title")}
          </h1>
          <p className="text-lg text-muted-foreground">
            {t("landing:contact.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className={cn(SURFACE_STYLES.card, "flex gap-4 p-6 rounded-2xl")}>
              <div className="p-3 bg-primary/10 text-primary rounded-xl h-fit">
                <Mail className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-1">
                  {t("landing:contact.talk_sales_title")}
                </h3>
                <p className="text-sm text-muted-foreground mb-3">
                  {t("landing:contact.talk_sales_body")}
                </p>
                <a
                  href="mailto:hello@fysaro.com"
                  className="text-primary font-medium hover:underline text-base"
                >
                  hello@fysaro.com
                </a>
              </div>
            </div>

            <div className={cn(SURFACE_STYLES.card, "flex gap-4 p-6 rounded-2xl")}>
              <div className="p-3 bg-primary/10 text-primary rounded-xl h-fit">
                <Languages className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-1">
                  {t("landing:contact.languages_title")}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {t("landing:contact.languages_body")}
                </p>
                <div className="flex gap-2 mt-3">
                  <span className="text-xs bg-muted px-2.5 py-1 rounded-full font-medium">
                    🇪🇸 ES
                  </span>
                  <span className="text-xs bg-muted px-2.5 py-1 rounded-full font-medium">
                    🇬🇧 EN
                  </span>
                  <span className="text-xs bg-muted px-2.5 py-1 rounded-full font-medium">
                    🇮🇹 IT
                  </span>
                </div>
              </div>
            </div>

            <div className={cn(SURFACE_STYLES.card, "rounded-2xl p-6 space-y-4")}>
              <h3 className="text-lg font-bold">{t("landing:contact.talking_title")}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {t("landing:contact.talking_body_a")}
              </p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {t("landing:contact.talking_body_b")}
              </p>
              <span className="inline-block text-xs text-primary font-medium bg-primary/10 px-3 py-1.5 rounded-full">
                {t("landing:contact.talking_footer")}
              </span>
            </div>
          </div>

          <PublicContactForm />
        </div>
      </main>
    </PublicClinicShell>
  );
}
